(() => {
  const refresh = async root => {
    const grid = root.querySelector('.collection-products > div:not(.loading-overlay)');
    if (!grid || root.dataset.loading === 'true') return;
    root.dataset.loading = 'true';
    const limit = Number(root.dataset.limit);
    const chosen = [], seen = new Set();
    let url = new URL(root.dataset.source, location.origin);
    url.searchParams.set('view', 'tcp-arrivals');
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.set('page', '1');
    try {
      while (url && chosen.length < limit) {
        const response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error('New arrivals request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = doc.querySelector('[data-tcp-arrivals-feed]');
        if (!feed) throw new Error('New arrivals feed missing');
        for (const card of feed.querySelectorAll('article.collection-product[data-available="true"]')) {
          if (!seen.has(card.id)) { chosen.push(card); seen.add(card.id); }
          if (chosen.length === limit) break;
        }
        url = feed.dataset.next ? new URL(feed.dataset.next, location.origin) : null;
        if (url) {
          url.searchParams.set('view', 'tcp-arrivals');
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('filter.v.availability', '1');
        }
      }
      if (!root.isConnected) return;
      grid.replaceChildren(...chosen.map(card => document.importNode(card, true)));
      root.dataset.refreshed = 'true';
    } catch (error) {
      console.warn('New arrivals update unavailable', error);
    } finally {
      root.dataset.loading = 'false';
    }
  };
  const init = () => document.querySelectorAll('[data-tcp-new-arrivals]').forEach(refresh);
  if (!window.TCPNewArrivals) {
    window.TCPNewArrivals = { init };
    document.addEventListener('shopify:section:load', init);
    window.addEventListener('pageshow', init);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) init(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
